import { render } from "./WaterControl.vue?vue&type=template&id=991e8710&scoped=true"
import script from "./WaterControl.vue?vue&type=script&lang=js"
export * from "./WaterControl.vue?vue&type=script&lang=js"

import "./WaterControl.vue?vue&type=style&index=0&id=991e8710&scoped=true&lang=css"
import "./WaterControl.vue?vue&type=style&index=1&id=991e8710&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-991e8710"]])

export default __exports__